import { Injectable } from '@angular/core';
import { FirebaseApp } from '@angular/fire/app';
import { Analytics, getAnalytics, logEvent } from "firebase/analytics";


@Injectable({
	providedIn: 'root'
})
export class AnalyticsService {

	private _analytics: Analytics;

	init(app: FirebaseApp): void {
		if (!app) {
			return;
		}
		if (typeof window !== 'undefined') {
			this._analytics = getAnalytics(app);
		}
	}

	log(event: string, params?: any): void {
		logEvent(this._analytics, event, params, null);
	}
}
